module.exports = __webpack_public_path__ + "img/portugues.2be53e51.svg";